const BASE_PATH = "app/admin/insights/";

export const SET_PAGE_OPEN = `${BASE_PATH}set-page-open`;
export const SET_APP_ERRORS = `${BASE_PATH}set-app-errors`;
export const SET_APP_PAGE_OPEN = `${BASE_PATH}set-app-page-opens`;
export const SET_INTEREST_EXPRESS = `${BASE_PATH}set-app-interest-express`;
export const SET_MISCELLANEOUS = `${BASE_PATH}set-app-miscellaneous-matrix`;
export const SET_SUBSCRIPTIONS = `${BASE_PATH}set-app-subscriptions-matrix`;
